import { getDB } from "src/db/databases"
import { useCacheStore } from "src/stores/cacheStore"
import { Log } from "src/util/classes/log"
import { getItemClass } from "src/util/http/csi/itemClasses"
import { ItemClass } from "src/util/types/dataModels/itemClass"

export async function getItemClassData(itemClassId: string): Promise<ItemClass | undefined> {
  const cacheStore = useCacheStore()

  try {
    const itemClassInCache = cacheStore.item_class.get(itemClassId)

    if (itemClassInCache) {
      return itemClassInCache
    } else {
      const db = await getDB()
      const itemClassInDB = await db.item_class.findOne(itemClassId).exec()

      if (itemClassInDB) {
        const itemClassMutated = itemClassInDB.toMutableJSON()
        cacheStore.item_class.set(itemClassMutated.id, itemClassMutated)
        return itemClassMutated
      } else {
        return await getItemClass({}, itemClassId)
      }
    }
  } catch (error) {
    Log.error({
      message: "An error occurred while fetching Item Class data",
      error,
    })
  }
}
